import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  author: string;
  role?: string;
  avatar?: string;
};
type TestimonialsProps = {
  testimonials: Testimonial[];
  title?: string;
  subtitle?: string;
  background?: 'white' | 'blush';
};
export function Testimonials({
  testimonials,
  title = 'What SLPs are saying',
  subtitle,
  background = 'white'
}: TestimonialsProps) {
  const bg = background === 'white' ? 'bg-white' : 'bg-blush';
  return <section aria-label={title} className={`w-full text-ink ${bg}`} data-id="element-282" data-mp="31zwab52n92fz">
      <div className="max-w-6xl mx-auto px-5 py-16 sm:py-20" data-id="element-283" data-mp="31yl8vbwo86s1">
        <div className="text-center" data-id="element-284" data-mp="2x1urml94r551">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold-deep" data-id="element-285" data-mp="2x2w3grxyzvnt">
            SLP to SLP
          </p>
          <h2 className="mt-3 font-display text-plum text-3xl sm:text-5xl" data-id="element-286" data-mp="v96ijv9t1nhc">
            {title}
          </h2>
          {subtitle && <p className="mx-auto mt-4 max-w-2xl text-sm text-ink-soft" data-id="element-287" data-mp="qbn7f48elqtm">
              {subtitle}
            </p>}
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-288" data-mp="h8az7g8j0vsa">
          {testimonials.map((item, i) => <figure key={i} className="rounded-3xl border border-cream-dark bg-white p-5 shadow-card" data-id="element-289" data-mp="780j9nv3xa9f" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-290" data-mp="c7n0e8e23ani">
                {item.avatar ? <img src={item.avatar} alt={item.author} width={44} height={44} loading="lazy" className="h-11 w-11 rounded-full object-cover ring-2 ring-cream-dark" data-id="element-291" data-mp="zxr0w6vy6uaa" /> : <span className="flex h-11 w-11 items-center justify-center rounded-full bg-plum font-display text-[13px] text-gold" data-id="element-292" data-mp="v3mqterdy64z">
                    {item.author.replace(/[^A-Za-z ]/g, '').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase() || 'SR'}
                  </span>}
                <span className="flex gap-0.5" aria-label="Five out of five" data-id="element-293" data-mp="1ogjca6auskgt">
                  {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-294" data-mp="1jhpvo509sdcf" />)}
                </span>
              </div>
              <blockquote className="mt-3 text-[15px] leading-relaxed text-ink" data-id="element-295" data-mp="14t22u6ht6hq6">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 text-xs text-ink-soft" data-id="element-296" data-mp="10t1dvrx32o4v">
                <span className="block text-[13px] font-semibold not-italic text-plum" data-id="element-297" data-mp="vt6nrql4u2kv">
                  {item.author}
                </span>
                {item.role}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}